import { useState, useEffect } from "react";

export const useCityName = () => {
  const STORAGE_KEY = "city_name";

  const [cityName, setCityName] = useState(() => {
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored ? stored.trim() : "Bangalore";
  });

  useEffect(() => {
    if (cityName) {
      localStorage.setItem(STORAGE_KEY, cityName);
    }
  }, [cityName]);

  return { cityName, setCityName };
};
